export default __webpack_public_path__ + "static/media/dcode.273fbbe3.png";